import * as React from "react";
import {observer} from "mobx-react";
import {
  ListItem,
  ListItemIcon,
  ListItemContent,
  ListItemDropdown,
} from "./components";
import AnimateHeight from "react-animate-height";
import {ListBoardPropsList, ListBoardPropsRender} from "./types";

interface Props<T> extends ListBoardPropsRender<T> {
  list: ListBoardPropsList<T>;
  item: T;
}

@observer
export class ListBoardItem<T> extends React.Component<Props<T>, { dropped: boolean }> {

  constructor(props: Props<T>) {
    super(props);
    this.state = { dropped: false };
  }

  render() {
    const { props } = this;
    const { item, list } = props;
    return (
      <ListItem onClick={() => this.setState({ dropped: !this.state.dropped })}>

        <ListItemContent>
          <ListItemIcon>
            {props.renderIcon(item, list)}
          </ListItemIcon>
          {props.renderRow(item, list)}
        </ListItemContent>

        {(props.renderRowDropdown) && (
          <AnimateHeight height={this.state.dropped ? "auto" : "0"}>
            <ListItemDropdown>
              {props.renderRowDropdown(item, list)}
            </ListItemDropdown>
          </AnimateHeight>
        )}

      </ListItem>
    );
  }

}
